import React from "react";
import Sample1 from "../../assets/images/Portfolio/Sample1";
import Sample2 from "../../assets/images/Portfolio/Sample2";
import Sample3 from "../../assets/images/Portfolio/Sample3";
// import Sample4 from "../../assets/images/Portfolio/Sample4";
// import Sample5 from "../../assets/images/Portfolio/Sample5";
import Sample6 from "../../assets/images/Portfolio/Sample6";
// import Sample7 from "../../assets/images/Portfolio/Sample7";

import { Link } from "react-router-dom";
import LogoDark from "../../assets/images/Logo/LogoDark";
import styles from "./Portfolio.module.css"; // Import the CSS module
import LogoWhite from "../../assets/images/Logo/LogoWhite";

function Portfolio() {
  return (
    <div className={styles.responsiveBody}>
      <div className={styles.hero}>
        <div className={`${styles.navbar} ${styles.container}`}>
          <div className={styles.navbarLogo}>
            <LogoWhite className={styles.navbarLogoImage} />
            <div className={styles.navbarLogoText}>Start</div>
          </div>
          <div className={`${styles.navbarMenu} ${styles.hidden}`}>
            <Link to="/" className={styles.navbarMenu1}>
              Home
            </Link>
            <Link to="/portfolio" className={styles.navbarMenu2}>
              Portfolio
            </Link>
            <Link to="/services" className={styles.navbarMenu3}>
              Pro Services
            </Link>
            <Link to="/contact" className={styles.navbarMenu4}>
              Contact
            </Link>
          </div>

          <div className={styles.navbarIcons}>
            <i className="bi bi-list"></i>
            <i className="bi bi-x-lg hide"></i>
          </div>
        </div>
      </div>

      <div className={`${styles.sectionOne} ${styles.container}`}>
        <div
          className={`${styles.sectionOneContent} ${styles.textCenter} ${styles.flex}`}
        >
          <div
            className={`${styles.sectionOneContentLabel} ${styles.label} ${styles.textGreen}`}
          >
            portfolio
          </div>
          <div
            className={`${styles.sectionOneContentTitle} ${styles.commonTitle}`}
          >
            Lorem ipsum dolor sit amet consectetur.
          </div>
          <div className={styles.sectionOneContentText}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae,
            porro?
          </div>
        </div>
        <div className={styles.sectionOneImages}>
          <Sample1 className={styles.responsiveImage} />
          <Sample2 className={styles.responsiveImage} />
          <Sample3 className={styles.responsiveImage} />
          {/* <Sample4 className={styles.responsiveImage} /> */}
          {/* <Sample5 className={styles.responsiveImage} /> */}
          <Sample6 className={styles.responsiveImage} />
          <Sample6 className={styles.responsiveImage} />
          {/* <Sample7 className={styles.responsiveImage} /> */}
          <img
            className={styles.responsiveImage}
            src="src/images/Portfolio/sample-8.png"
            alt=""
          />
        </div>
        <button className={`${styles.sectionOneBtn} ${styles.darkBtn}`}>
          Learn More
        </button>
      </div>

      <div className={styles.footerWrapper}>
        <div className={`${styles.footerMenu} ${styles.container}`}>
          <div className={styles.footerMenuLeft}>
            <LogoDark className={styles.footerMenuLeftLogo} />
            <div className={styles.footerMenuLeftText}></div>
          </div>
          <div className={styles.footerMenuRight}></div>
        </div>

        <div className={`${styles.footerLinks} ${styles.container}`}>
          <div className={styles.footerLinksSocials}></div>
          <div
            className={`${styles.footerLinksCopyright} ${styles.textWhite} ${styles.textCenter}`}
          >
            © Start, 2022. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
